import React, { useState } from 'react';
import { Check, Loader2, ShieldCheck } from 'lucide-react';
interface CaptchaProps {
  onVerify: (token: string) => void;
  className?: string;
}
export function Captcha({
  onVerify,
  className = ''
}: CaptchaProps) {
  const [status, setStatus] = useState<'idle' | 'verifying' | 'verified'>('idle');
  const handleVerify = async () => {
    if (status !== 'idle') return;
    setStatus('verifying');
    // Simulate the time it takes for a real captcha (like reCAPTCHA) to analyze interaction
    setTimeout(() => {
      setStatus('verified');
      // Generate a mock token
      const mockToken = 'captcha_token_' + Math.random().toString(36).substr(2);
      onVerify(mockToken);
    }, 1500);
  };
  return <div className={`bg-[#F9F9F9] border border-[#E0E0E0] rounded-md p-3 flex items-center justify-between shadow-sm select-none ${className}`} data-id="element-197">
      <div className="flex items-center gap-3" data-id="element-198">
        <button type="button" onClick={handleVerify} disabled={status !== 'idle'} className={`
            w-6 h-6 rounded border-2 flex items-center justify-center transition-all duration-200
            ${status === 'idle' ? 'border-[#C0C0C0] bg-white hover:border-[#A0A0A0]' : ''}
            ${status === 'verifying' ? 'border-transparent bg-transparent' : ''}
            ${status === 'verified' ? 'border-[#25D366] bg-[#25D366]' : ''}
          `} aria-label="I am not a robot" data-id="element-199">
          {status === 'verifying' && <Loader2 className="h-5 w-5 text-[#8B7355] animate-spin" data-id="element-200" />}
          {status === 'verified' && <Check className="h-4 w-4 text-white" strokeWidth={3} data-id="element-201" />}
        </button>
        <span className="text-sm text-[#5C5C5C] font-medium cursor-pointer" onClick={handleVerify} data-id="element-202">
          I am not a robot
        </span>
      </div>

      <div className="flex flex-col items-center justify-center opacity-70" data-id="element-203">
        <ShieldCheck className="h-8 w-8 text-[#8B7355]" data-id="element-204" />
        <span className="text-[8px] text-[#8B7355] mt-0.5 font-medium" data-id="element-205">
          reCAPTCHA
        </span>
        <div className="text-[6px] text-[#5C5C5C] flex gap-1" data-id="element-206">
          <span data-id="element-207">Privacy</span>
          <span data-id="element-208">-</span>
          <span data-id="element-209">Terms</span>
        </div>
      </div>
    </div>;
}